import { StatusPill } from "procurement/design"

const StatusBadge = ({ status, label }) => <StatusPill status={status} label={label} />

export default StatusBadge
